import { cn } from '@/src/utils/styles'

interface StepLineProps {
  isActive?: boolean
  isError?: boolean
  isSuccess?: boolean
  className?: string
  height?: number
}

export const StepLine = ({
  isActive,
  isError,
  isSuccess,
  className,
  height,
}: StepLineProps) => (
  <div
    className={cn(
      'w-0.5 h-3 bg-border2',
      {
        'bg-accent-primary': isActive,
        'bg-danger-text': isError,
        'bg-success-text': isSuccess,
      },
      className,
    )}
    style={{
      height: height,
    }}
  />
)
